import React, { FC } from 'react'
import { FixedLayout } from 'components/Layout'
import { RegisterErrorTemplate } from 'components/Templates'

const RegisterError: FC = () => {
  return (
    <FixedLayout title={'アカウント登録有効期限切れ'}>
      <RegisterErrorTemplate />
    </FixedLayout>
  )
}

export default RegisterError
